
export const BASE_URL = "https://api.picstr.live";
